import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import * as SessionActions from '../../stores/actions/session';
import WaitingIndicator from '../general-components/waiting-indicator';
import useMediaDevices from '../../hooks/use-media-devices';

export default function ConfirmAppEntry() {
	const dispatch = useDispatch();
	const { checkMediaDevices } = useMediaDevices();

	useEffect(() => {
		checkMediaDevices()
			.then(() => dispatch(SessionActions.setOnboardingComplete(true)));
	}, []);

	return (
		<div className='position-absolute align-items-center width-full height-full'>
			<WaitingIndicator />
		</div>
	);
}
